// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { Organization, OrganizationCoursePermissionInterface, OrganizationCoursePermissionLayerLinkInterface } from '@/vue3/api/models';

export const useOrganizationService = () => {
    // hooks
    const store = useStore();
    const axios = useAxios();

    // properties
    const url = store.state.apiUrl;
    const organizations = ref<Organization[]>([]);

    // methods
    const getAllOrganization = async (): Promise<Organization[]> => {
        const res = await axios.get(`${url}/organization`);
        organizations.value = res.data;
        return res.data;
    };

    const getOrganization = async (id: number): Promise<Organization> => {
        const res = await axios.get(`${url}/organization/${id}`);
        return res.data;
    };

    const createOrganization = async (
        organization: Organization,
    ): Promise<Organization> => {
        const res = await axios.post(`${url}/organization`, organization);
        await getAllOrganization();
        return res.data;
    };

    const updateOrganization = async (
        organization: Organization,
    ): Promise<Organization> => {
        const res = await axios.put(`${url}/organization`, organization);
        await getAllOrganization();
        return res.data;
    };

    const deleteOrganization = async (id: number): Promise<Organization> => {
        const res = await axios.deleteId(`${url}/organization/${id}`);
        await getAllOrganization();
        return res.data;
    };

    const getOrganizationAllCourseLayerPermission = async (organizationId: number) : Promise<Array<OrganizationCoursePermissionInterface>> => {
        const res = await axios.get(`${url}/organization/layer-permission/all-courses/${organizationId}`);
        if(!res.data){
            return []
        }
        return res.data;
    }

    const getOrganizationCourseLayerPermission = async (organizationId: number, courseSchemaId: number): Promise<OrganizationCoursePermissionInterface> => {
        const res = await axios.get(`${url}/organization/layer-permission/${courseSchemaId}/${organizationId}`);
        if (!res.data) {
            return {
                course_schema_id: 0,
                course_schema_name: '',
                course_schema_display_name: '',
                layer: []
            }
        }
        return res.data;
    }

    const updateOrganizationCourseLayerPermission = async (updatedCourseLayerPermissions: Array<OrganizationCoursePermissionLayerLinkInterface>, organizationId: number) : Promise<any> => {
        const {status} = await axios.post(`${url}/organization/layer-permission/all-courses/${organizationId}`, updatedCourseLayerPermissions);
        if(status === 200){
            return true
        }
        return false;
    }

    const getOrganizationsByCourseSchema = async (courseSchemaId: number): Promise<Organization[]> => {
        const res = await axios.get(`${url}/organization/by-course-schema/${courseSchemaId}`);
        return res.data;
    }
    const getOrganizationCustomCourses = async (organizationId: number): Promise<any[]> => {
        const res = await axios.get(`${url}/organization/${organizationId}/custom-courses`);
        return res.data || [];
    };

    return {
        organizations,
        getAllOrganization,
        getOrganization,
        createOrganization,
        updateOrganization,
        deleteOrganization,

        getOrganizationAllCourseLayerPermission,
        getOrganizationCourseLayerPermission,
        updateOrganizationCourseLayerPermission,
        getOrganizationsByCourseSchema,
        getOrganizationCustomCourses,
    };
};
